import React from 'react';

import { Chip } from '@/shared/components/ui/chip/chip';
import { TUserSourceChipProps } from '@/shared/features/rbac/components/user-source-chip/user-source-chip.types';
import { UserSourceEnum } from '@/shared/types/types.generated';
import { getResellerBranding } from '@/shared/utils/reseller-branding/reseller-branding';

export const UserSourceChip: React.FC<TUserSourceChipProps> = ({
  userSource,
}) => {
  const resellerAbbreviation = getResellerBranding().abbreviation;

  return (
    <Chip
      status={userSource === UserSourceEnum.Sda ? 'grey' : 'purple'}
      label={
        userSource === UserSourceEnum.Sda ? resellerAbbreviation : userSource
      }
    />
  );
};
